import cn from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'

import Scroller from 'components/Scroller'
import { selectNewSideBarEnabled } from 'ducks/crm/selectors'
import SUI from 'shared/components/ui/SUI'

import InAppCards from './InAppCards'
import NewRightSidebar from './New'
import styles from './styles.css'

function ExpandedContent({ showTicketLocation, panelWidth }) {
  const newSidebarEnabled = useSelector(selectNewSideBarEnabled)
  if (newSidebarEnabled) return <NewRightSidebar width={panelWidth} />
  return (
    <div className={cn(styles.rightCell)}>
      <div className={styles.ExpandedContent}>
        <div className={styles.content}>
          <Scroller>
            <div className={styles['content-inner']}>
              {showTicketLocation && (
                <React.Fragment>
                  <SUI>
                    <InAppCards />
                  </SUI>
                </React.Fragment>
              )}
            </div>
          </Scroller>
        </div>
      </div>
    </div>
  )
}

export default ExpandedContent
